import {
  address,
  coordinate,
  offerBadge,
} from 'services/graphql/fragments/Fragments';
import { AnalyticsEventFragment } from 'services/graphql/fragments/HomeTilesContentFragment';
import { gql } from 'urql';

const gqlQuery = gql`
  query PartnerOfferDetails($id: ID!, $location: GeoCoordinateInput) {
    myPartnerOffers {
      offer(id: $id, location: $location) {
        id
        name
        industry
        shortDescription
        cashbackAmount
        cashbackDescription
        heroImage
        logoImage
        isOptInRequired
        benefitsTitle
        benefitsContent
        aboutTitle
        aboutContent
        bodySection3Title
        description
        terms
        disclaimer
        offerType
        offerSource
        offerBracket
        displayAnalytics {
          ...AnalyticsEventFragment
        }
        badge {
          ...offerBadge
        }
        cta {
          __typename
          id
          url
          title
          action
          backgroundColour
        }
        legalText
        legalUrl
        address {
          ...address
        }
        addressHTML
        coordinate {
          ...coordinate
        }
        coordinates {
          ...coordinate
        }
        redemptionLocationInfo {
          __typename
          icon
          text
          trailingText
        }
        cardUsageInfo {
          __typename
          icon
          text
        }
        maxEarningsInfo {
          __typename
          icon
          text
          trailingText
        }
        sourceMerchantId
        merchantId
        primaryButton {
          __typename
          id
          buttonText
          buttonStyle
          buttonOnClick {
            __typename
            ... on OpenURLNavigationAction {
              analyticsEvent {
                ...AnalyticsEventFragment
              }
              url
            }
          }
        }
        secondaryButton {
          __typename
          id
          buttonText
          buttonStyle
          buttonOnClick {
            __typename
            ... on OpenURLNavigationAction {
              analyticsEvent {
                ...AnalyticsEventFragment
              }
              url
            }
          }
        }
        tag {
          __typename
          icon
          id
          tagColor
          text
        }
        mapData {
          __typename
          center {
            __typename
            latitude
            longitude
          }
          markerLocation {
            __typename
            latitude
            longitude
          }
          previewImage
        }
        howItWorks {
          title
          steps
        }
      }
    }
  }
  ${address}
  ${AnalyticsEventFragment}
  ${coordinate}
  ${offerBadge}
`;

export default gqlQuery;
